export default {
  system: {
    loading: "loading...",
    project_name: "Self Isolation Assistance"
  },
  home: {
    welcome: "Welcome"
  },
  welcome: {
    incorrect_link: "This link is incorrect",
    introduction:
      "Self isolation is critical to combat the COVID19 pandemic. This is a necessary step we all need to take to help flatten the curve and to protect those around us.",
    guidance_use_phone:
      "This site will use your phone's features to detect where you are.",
    guidance_grant_permission_1: "Please grant the permission required ",
    guidance_grant_permission_2:
      "to use your current location. This tool will ensure you comply with self-isolation rules. Please contact your local authorities if you have any questions.",
    guidance_enable_location:
      "If your location feature is disabled, please enable it via settings.",
    additional_iphone_link_text: "Additional iPhone information",
    additional_android_link_text: "Additional Android information",
    start_button: "Start"
  },
  locate: {
    report_location_button: "Report Your Location",
    geolocation_not_available_tips: "Your phone does not support location",
    geolocation_not_enabled_tips:
      "Please enable location features and try again",
    reported_location: "Your reported location",
    latitude: "Latitude",
    longitude: "Longitude",
    thank_introduction:
      "Thank you for your cooperation, please ensure you self isolate for 14 days for everyone's safety. Click the button to submit your results.",
    getting_location_data: "Getting the location data"
  },
  thank: {
    thank_you: "Thank you",
    thank_cooperation:
      "Thank you for your cooperation, remember to wash your hands"
  },
  android: {
    setting_title: "Android Settings",
    introduction:
      "You can change your browser's Location Settings via these simple steps, you only need to do this once.",
    setting_step_1: "Go to Settings",
    setting_step_2: "Choose Security & location",
    setting_step_3: "Scroll down and choose Location",
    setting_step_4: "Ensure it is On"
  },
  iphone: {
    setting_title: "iPhone Settings",
    introduction:
      "You can change your browser's Location Settings via these simple steps, you only need to do this once.",
    setting_step_1: "Go to Settings",
    setting_step_2: "Choose Privacy",
    setting_step_3: "Choose Location Services, ensure it is On",
    setting_step_4: 'Scroll down to "Safari Websites", and select it',
    setting_step_5: 'Ensure it is selected "While Using the App"'
  }
};
